export default __webpack_public_path__ + "static/media/m05-7.7978e211.png";